import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent {
  
  @Input() placeholder: string = 'Search...'; // default placeholder
  @Input() value: string = ''; // optional initial value
  @Output() search: EventEmitter<string> = new EventEmitter();

  private searchSubject: Subject<string> = new Subject();

  constructor() {
    // debounce typing to avoid too many events
    this.searchSubject.pipe(debounceTime(300)).subscribe(val => {
      this.search.emit(val);
    });
  }

  onInput(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this.searchSubject.next(val);
  }

  clear() {
    this.value = '';
    this.searchSubject.next('');
  }
}
